import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { noteStateType } from "./types";
import {
  linkProject,
  linkTask,
  unlinkProject,
  unlinkTask,
} from "../objectives/objectives.thunk";

type Link = { objectiveId: string | null; keyResultId: string | null };

/**
 * Keeps objectiveId/keyResultId on projects and tasks in sync when they are
 * linked to a goal - in the lists and in the opened project/task (the
 * objectives slice gets the updated goal itself).
 */
export function addObjectiveLinkReducers(
  builder: ActionReducerMapBuilder<noteStateType>,
) {
  const setProjectLink = (
    state: noteStateType,
    projectId: string,
    link: Link,
  ) => {
    for (const project of [
      state.projects?.find((p) => p.id === projectId),
      state.project?.id === projectId ? state.project : undefined,
    ]) {
      if (project) Object.assign(project, link);
    }
  };

  const setTaskLink = (state: noteStateType, taskId: string, link: Link) => {
    for (const task of [
      state.tasks.find((t) => t.id === taskId),
      state.task?.id === taskId ? state.task : undefined,
    ]) {
      if (task) Object.assign(task, link);
    }
  };

  const unlinked: Link = { objectiveId: null, keyResultId: null };

  builder
    .addCase(linkProject.fulfilled, (state, action) => {
      const { projectId, objectiveId, keyResultId } = action.meta.arg;
      setProjectLink(state, projectId, {
        objectiveId,
        keyResultId: keyResultId ?? null,
      });
    })
    .addCase(unlinkProject.fulfilled, (state, action) => {
      setProjectLink(state, action.meta.arg.projectId, unlinked);
    })
    .addCase(linkTask.fulfilled, (state, action) => {
      const { taskId, objectiveId, keyResultId } = action.meta.arg;
      setTaskLink(state, taskId, {
        objectiveId,
        keyResultId: keyResultId ?? null,
      });
    })
    .addCase(unlinkTask.fulfilled, (state, action) => {
      setTaskLink(state, action.meta.arg.taskId, unlinked);
    });
}
